<script setup lang="ts">
import { ref } from 'vue';
import Iframe from '../../General/Iframe.vue';
import Fullscreen from '../../General/Fullscreen.vue';
import { utils } from '../../../utils';

const summaryUrl = ref<string>('')
</script>

<template>
    <div class="p-3 flex flex-col overflow-auto h-full">
        <div class="flex items-center justify-center gap-2 w-full mt-3">
            <div class="font-bold">Summary</div>
            <input v-model="summaryUrl"
                class="w-full max-w-3xl outline-none block rounded-full border-0 py-2 px-4 text-gray-600 ring-2 ring-inset ring-gray-300 placeholder:text-gray-600 focus:ring-2 focus:ring-inset focus:ring-orange-600" />
        </div>

        <Fullscreen v-if="utils.isValidUrl(summaryUrl)" class="mt-3 h-full">
            <Iframe :src="summaryUrl" orientation="full" />
        </Fullscreen>
    </div>
</template>